import { DeleteConfirmPopup } from '@shared/ui/delete-confirm-popup';
import { SixDotsIcon, TrashIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { ReactNode, useState, useRef } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormItemWrapperProps {
  children: ReactNode;
  instanceId?: string;
  onDelete?: (instanceId: string) => void;
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  dragStyles?: stylex.StyleXStyles | stylex.StyleXStyles[];
  isDraggedOver?: boolean;
  isDragging?: boolean;
  isHideHud?: boolean;
  isHideActions?: boolean;
}

export const FormItemWrapper = ({
  children,
  instanceId,
  onDelete,
  draggable,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop,
  dragStyles,
  isDraggedOver,
  isDragging,
  isHideHud,
  isHideActions,
}: FormItemWrapperProps) => {
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const deleteButtonRef = useRef<HTMLButtonElement>(null);

  const handleConfirmDelete = () => {
    instanceId && onDelete?.(instanceId);
    setIsDeletePopupOpen(false);
  };

  return (
    <div
      {...stylex.props(
        styles.formItemWrapper,
        !isHideHud && styles.container,
        isDragging && styles.containerDragging,
        isDraggedOver && styles.containerDraggedOver,
        dragStyles
      )}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      onDropCapture={onDrop}
    >
      <div {...stylex.props(!isHideHud && styles.content)} style={{ position: 'relative' }}>
        {children}

        {!isHideActions && (
          <>
            <UnstyledButton onClick={() => setIsDeletePopupOpen(true)}>
              <span {...stylex.props(styles.removeButton)} ref={deleteButtonRef}>
                <TrashIcon color={palette['grey-950']} />
              </span>
            </UnstyledButton>

            <UnstyledButton>
              <span {...stylex.props(styles.moveButton)}>
                <SixDotsIcon color={colors.secondaryBackground} />
              </span>
            </UnstyledButton>

            <DeleteConfirmPopup
              isOpen={isDeletePopupOpen}
              onClose={() => setIsDeletePopupOpen(false)}
              onConfirm={handleConfirmDelete}
              anchorRef={deleteButtonRef}
            />
          </>
        )}
      </div>
    </div>
  );
};
